import { render } from "./GestãoDeAcessoComponent.vue?vue&type=template&id=440807de&scoped=true"
import script from "./GestãoDeAcessoComponent.vue?vue&type=script&lang=js"
export * from "./GestãoDeAcessoComponent.vue?vue&type=script&lang=js"

import "./GestãoDeAcessoComponent.vue?vue&type=style&index=0&id=440807de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440807de"]])

export default __exports__